/**
 * Row identity for the temporal grid: one home for the format, used by
 * `ForecastDataTable.getRowId` and by the retained row patch, which must key
 * rows the same way or its edits land on nothing.
 *
 * Fiscal and gregorian rows carry the year in different fields, so the id
 * differs per calendar family, which keeps one family's retained rows off
 * the other's.
 */
export function forecastRowId(row: {
  year?: unknown;
  fiscal_year_name?: unknown;
  metric_name?: unknown;
  producer_type?: unknown;
}): string {
  return `${row.year ?? row.fiscal_year_name}_${row.metric_name}_${row.producer_type}`;
}

/** {@link forecastRowId} for callers holding the fields loose rather than a row. */
export function createRowId(
  fiscalYearName: string,
  metricName: string,
  producerType: string
): string {
  return forecastRowId({
    fiscal_year_name: fiscalYearName,
    metric_name: metricName,
    producer_type: producerType
  });
}
